import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Register from '@/components/Register'
import Register1 from '@/components/Register1'
import ReturnPassword from '@/components/ReturnPassword'
import ReturnPassword1 from '@/components/ReturnPassword1'
//import ReturnPassword2 from '@/components/ReturnPassword2'
import Step1 from '@/components/Step1'
import Step2 from '@/components/Step2'
import Step22 from '@/components/Step22'
import Step3 from '@/components/Step3'
import Invoice from '@/components/Invoice'
import Person1 from '@/components/Person1'
import Person2 from '@/components/Person2'
import Search from '@/components/Search'
import Table from '@/components/Table'
import Table1 from '@/components/Table1'
import Appoint from '@/components/Appoint'
import Index from '@/components/Index'
import Form from '@/components/Form'
import RegisterRule from '@/components/RegisterRule'
import Agreement from '@/components/Agreement'
import Convention from '@/components/Convention'
import PiaoTemplate from '@/components/PiaoTemplate'
import Activity from '@/components/Activity'

import axios from '../untils/http'

//import store from '../store/index'

Vue.use(Router)
const querystring = require("querystring");

const router = new Router({
	mode: 'history',
  	routes: [	 
	    {
	      path: '/login',
	      name: 'login',
	      component: resolve => require(['@/components/Login'], resolve)
	    },	
	    
	     {
	      path: '/activity',
	      name: 'activity',
	      component: resolve => require(['@/components/Activity'], resolve)
	    },	
	    	    
	    {
	      path: '/returnPassword',
	      name: 'returnPassword',
	      component: resolve => require(['@/components/ReturnPassword'], resolve)
	    },
	    
	    {
	      path: '/returnPassword1',
	      name: 'returnPassword1',
	      component: resolve => require(['@/components/ReturnPassword1'], resolve)
	    },
	    
//	    {
//	      path: '/returnPassword2',
//	      name: 'returnPassword2',
//	      component: resolve => require(['@/components/ReturnPassword2'], resolve)
//	    },
	    
	    {
	      path: '/register',
	      name: 'register',
	      component: resolve => require(['@/components/Register'], resolve)
	    },
	    
	    {
	      path: '/register1',
	      name: 'register1',
	      component: resolve => require(['@/components/Register1'], resolve)
	    },
	    
	    {
	      path: '/registerRule',
	      name: 'registerRule',
	      component: resolve => require(['@/components/RegisterRule'], resolve)
	    },
	    {
	      path: '/agreement',
	      name: 'agreement',
	      component: resolve => require(['@/components/Agreement'], resolve)
	    },
	    {
	      path: '/convention',
	      name: 'convention',
	      component: resolve => require(['@/components/Convention'], resolve)
	    },
	    {
	      path: '/index',
	      name: 'index',
	      component: resolve => require(['@/components/Index'], resolve)
	    },
	    	   
	    {
	      path: '/step1',
	      name: 'step1',
	      component: resolve => require(['@/components/Step1'], resolve)
	    },
	    {
	      path: '/step2',
	      name: 'step2',
	      component: resolve => require(['@/components/Step2'], resolve)
	    },
	    {
	      path: '/step22',
	      name: 'step22',
	      component: resolve => require(['@/components/Step22'], resolve)
	    },
	    {
	      path: '/step3',
	      name: 'step3',
	      component: resolve => require(['@/components/Step3'], resolve)
	    },
	    
	     {
	      path: '/person1',
	      name: 'person1',
	      component: resolve => require(['@/components/Person1'], resolve)
	    },
	     {
	      path: '/person2',
	      name: 'person2',
	      component: resolve => require(['@/components/Person2'], resolve)
	    },
	    {
	      path: '/invoice',
	      name: 'invoice',
	      component: resolve => require(['@/components/Invoice'], resolve)
	    },	    
		
	    {
	      path: '/appoint',
	      name: 'appoint',
	      component: resolve => require(['@/components/Appoint'], resolve)
	    },
	    {
	      path: '/form',
	      name: 'form',
	      component: resolve => require(['@/components/Form'], resolve)
	    },	    
	    {
	      path: '/search',
	      name: 'search',
	      component: resolve => require(['@/components/Search'], resolve)
	    },
	    {
	      path: '/table',
	      name: 'table',
	      component: resolve => require(['@/components/Table'], resolve)
	    },
	    {
	      path: '/table1',
	      name: 'table1',
	      component: resolve => require(['@/components/Table1'], resolve)
	    },
	    {
	      path: '/piaoTemplate',
	      name: 'piaoTemplate',
	      component: resolve => require(['@/components/PiaoTemplate'], resolve)
	    },
	    	    
  	]
});

router.beforeEach((to, from, next) => {
	if(sessionStorage.getItem('Token') || to.path == '/login' || to.path == '/activity' || to.path =='/register' || to.path =='/register1' || to.path =='/returnPassword1' || to.path == '/search' || to.path == '/registerRule' || to.path == '/agreement' || to.path == '/convention' || to.path == '/invoice' || to.path == '/step22') {
		next()
  	}else{ 
  		next({path: '/login'})
	}
})

export default router








// WEBPACK FOOTER //
// ./src/router/index.js